<script setup>
import {useForm} from '@inertiajs/vue3'
import axios from "axios";
import {ref} from "vue";
import vueRecaptcha from 'vue3-recaptcha2';
import { values } from "lodash";
import { usePage } from '@inertiajs/vue3'
import DialogComponent from "../Dialogs/DialogComponent.vue";
import { Link } from '@inertiajs/vue3'

const page = usePage();

const form = useForm({
    email: '',
    captcha_token: null,
});

const recaptchaSiteKey = ref(page.props.recaptcha_site_key);
const vueRecaptchaInstance = ref(null);
const showRecaptcha = ref(false);
const message = ref('');
const title = ref('');

let dialog = ref({
    type: '',
    title: '',
    message: '',
    isOpen: false,
});

const openDialog = (type, title, message) => {
    dialog.value = {
        type: type,
        title: title,
        message: message,
        isOpen: true,
    };
}

const closeDialog = () => {
    dialog.value.isOpen = false;
}

const recaptchaVerified = (token) => {
    form.captcha_token = token;

    axios
        .post('/subscriptions', form.data())
        .then(result => {
            openDialog('success', 'Крит!', result?.data?.message);
            formReset();
        })
        .catch(error => {
            let title = 'Антикрит!';
            let message = '';

            if (error.response.status === 429) {
                title = 'Закончились очки действий'
                message = 'Кажется, у&nbsp;тебя уже есть подписка.<br>Но&nbsp;ты&nbsp;определённо можешь<br>попробовать позже';
            } else if (error.response.data?.errors && values(error.response.data.errors).length) {
                message = values(error.response.data.errors).join('<br>')
            } else {
                message = error?.message;
            }

            openDialog('error', title, message);
            formReset();
        });
};

const formReset = () => {
    form.reset();
    vueRecaptchaInstance.value.reset();
}
const recaptchaExpired = () => {
    formReset();
};
const recaptchaFailed = (a) => {
    console.log(a);
    console.log('failed recaptcha')
};
const recaptchaError = (reason) => {
    console.log(reason)
};

const validate = () => {
    vueRecaptchaInstance.value.execute();
};
</script>

<template>
    <label for="email" class="block text-3xl -tracking-[0.04em] lg:text-5xl xl:text-6xl font-extrabold leading-none">Напишем, когда&nbsp;качать</label>
    <form class="mt-8" autocomplete="off" @submit.prevent="validate">
        <div class="flex flex-col md:flex-row md:bg-white md:rounded-full">
            <input id="email"
                   type="email"
                   v-model="form.email"
                   class="sub-email flex-1 rounded-full md:rounded-l-full text-lg lg:text-2xl p-6 lg:px-8 text-black placeholder:text-slate-500 outline-none shadow-none"
                   required
                   pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                   placeholder="Сюда свой email">
            <vue-recaptcha
                v-show="showRecaptcha"
                :sitekey="recaptchaSiteKey"
                size="invisible"
                theme="light"
                hl="ru"
                :loading-timeout="30000"
                @verify="recaptchaVerified"
                @expire="recaptchaExpired"
                @fail="recaptchaFailed"
                @error="recaptchaError"
                ref="vueRecaptchaInstance">
            </vue-recaptcha>
            <button type="submit" class="btn mt-3 md:mt-0 submit text-orange outline-none shadow-none">
                <span class="btn-text">Подписаться</span>
                <span class="btn-hover-wrapper">
                    <span class="btn-hover">
                        <span>Подписаться</span>
                    </span>
                </span>
            </button>
        </div>
        <div class="mt-6 lg:mt-3 prose text-white max-w-none text-xs sm:text-sm md:text-md lg:text-[1rem]">
            Подписаться = согласиться с
            <Link :href="'/articles/agreement'">пользовательским соглашением</Link>
            и <Link :href="'/articles/politic'">политикой конфиденциальности</Link>
        </div>
        <div class="prose text-white max-w-[50%] text-[6px] md:text-[10px] absolute bottom-3 right-6 text-right">
            Защищено сервисом reCAPTCHA от Google
            <a href="https://policies.google.com/privacy" class="font-bold pr-3" target="_blank">Конфиденциальность</a>
            <a href="https://policies.google.com/terms" class="font-bold" target="_blank">Условия&nbsp;использования</a>
        </div>
    </form>
    <DialogComponent
        :type="dialog.type"
        :title="dialog.title"
        :message="dialog.message"
        :is-open="dialog.isOpen"
        @close="closeDialog"
    ></DialogComponent>
</template>

<style lang="scss">
    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 1000px #fff inset;
    }
</style>
